// Client voor de loginLink functie (functions/login-links). Wisselt het
// langlevende token uit een inlogknop in een e-mail in voor een verse Firebase
// sign-in link. Geeft { status: "ok" | "expired" | "invalid", email?, link? }.
const BASE_URL = process.env.REACT_APP_LOGIN_LINK_URL || "https://europe-west1-feestjegeven-nl.cloudfunctions.net/loginLink";

export async function redeemLoginToken(token) {
  const response = await fetch(BASE_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.error || "Er ging iets mis.");
  return data;
}
